import { EventBus } from '../utils/eventBus';

export type Theme = 'light' | 'dark';

export class ThemeService {
  private currentTheme: Theme;

  constructor(private eventBus: EventBus) {
    // Load saved theme or detect system preference
    const saved = localStorage.getItem('asknow_theme') as Theme;
    if (saved) {
      this.currentTheme = saved;
    } else {
      this.currentTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }

    this.applyTheme(this.currentTheme);
  }

  getTheme(): Theme {
    return this.currentTheme;
  }

  setTheme(theme: Theme): void {
    this.currentTheme = theme;
    localStorage.setItem('asknow_theme', theme);
    this.applyTheme(theme);
    this.eventBus.emit('theme:changed', theme);
  }

  toggleTheme(): void {
    const newTheme = this.currentTheme === 'light' ? 'dark' : 'light';
    this.setTheme(newTheme);
  }

  private applyTheme(theme: Theme): void {
    document.documentElement.setAttribute('data-theme', theme);
  }
}
